
import echarts from "echarts";
import { Component, Vue } from "vue-property-decorator";
import dataBox from "@/views/dashboard/components/dataBox.vue";
import DataBoxSimple from "@/views/dashboard/components/dataBoxSimple.vue";
import dataReport from "@/views/dashboard/components/dataReport.vue";
import dataLineChart from "@/views/dashboard/components/dataLinechart.vue";

@Component({
  name: "StoreDashboard",
  components: {
    dataBox,
    dataReport,
    DataBoxSimple,
    dataLineChart
  }
})
export default class StoreDashboard extends Vue {
  get simpleParameter(): any {
    const now = new Date();
    return {
      orgId: this.$store.getters['user/ouId'],
      onlyMe: false,
      year: now.getFullYear(),
      month: now.getMonth() + 1
    };
  }

  get yearlyParameter(){
    const now = new Date();
    return {
      orgId: this.$store.getters['user/ouId'],
      onlyMe: false,
      //year: now.getFullYear()
    };
  }

  // API参数
  buildYearlyReportApiParameters(year: number): any {
    const parameters = {
      OrgId: this.$store.getters['user/ouId'],
      Year: year
    };
    return parameters;
  }

  buildYearlySaleReportChartOption(res: any): any {
    return this.buildYearlyLineChartOption(res, "元");
  }

  buildYearlyNewVipCountChartOption(res: any): any {
    return this.buildYearlyLineChartOption(res, "个");
  }
  buildYearlyRenewVipCountChartOption(res: any): any {
    return this.buildYearlyLineChartOption(res, "个");
  }

  buildYearlyLineChartOption(res: any, unit: string): any {
    console.log(res, "res");
    const data = res.values.map((item: any) => item.value);
    const option: any = {
      grid: {
        left: "60px",
        right: "20px",
        top: "10px",
        bottom: "30px"
      },
      tooltip: {
        trigger: "axis",
        formatter: function(params: any) {
          return `${params[0].name}:${params[0].value}${unit}`;
        }
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ]
      },
      yAxis: {
        type: "value"
      },
      series: [
        {
          data: data,
          stack: "总量",
          type: "line"
        }
      ]
    };
    return option;
  }

  buildTestChartOption(res: any): any {
    const data = [];
    for (let i = 0; i < 7; i++) {
      data.push(parseInt((Math.random() * 1000).toFixed()));
    }
    const option: any = {
      grid: {
        left: "30px",
        right: "0px",
        top: "10px",
        bottom: "30px"
      },
      xAxis: {
        type: "category",
        data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
      },
      yAxis: {
        type: "value"
      },
      series: [
        {
          data: data,
          type: "line"
        }
      ]
    };
    return option;
  }
}
